import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkImages from 'remark-images';
import remarkUnwrapImages from 'remark-unwrap-images';
import MLink from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line no-irregular-whitespace, no-useless-escape
const youtubeRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;

const useStyles = makeStyles((theme) => ({
  youtubeContainer: {
    width: 450,
    maxWidth: '100%',
    margin: theme.spacing(2, 0)
  },
  youtubeEmbedWrapper: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: 30,
    height: 0,
    overflow: 'hidden',
    '& > iframe, & > object, & > embed': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  image: {
    maxWidth: '100%',
    maxHeight: 500,
  },
}));

const Markdown = (props) => {
  const classes = useStyles();

  return (
    <ReactMarkdown
      components={{
        a: function LinkRenderer(node) {
          const youtubeMatch = node.href ? node.href.match(youtubeRegex) : null;
          if (youtubeMatch) {
            return (
              <div className={classes.youtubeContainer}>
                <div className={classes.youtubeEmbedWrapper}>
                  <iframe
                    src={`https://www.youtube.com/embed/${youtubeMatch[1]}`}
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              </div>
            );
          }
          return <MLink {...node} rel="noopener noreferrer" />;
        },
        hr: function ThematicBreakRenderer(node) {
          return <Divider {...node} variant="middle" className={classes.divider} />;
        },
        img: function ImageRenderer(node) {
          return <img {...node} className={classes.image} />;
        },
      }}
      remarkPlugins={[
        remarkGfm,
        remarkImages,
        remarkUnwrapImages,
      ]}
      unwrapDisallowed
      {...props}
    />
  );
};

export default Markdown;
